var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForceReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.803,
    height: 34.5,
    viewBox: "0 0 25.803 34.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#424242;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4720.344 6753.452)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.602, 0.799, -0.799, 0.602, -4706.751, -6772.647)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.153,14.5c.2-.092.4-.17.611-.245l.133-.045c.145-.05.293-.092.441-.137s.29-.077.437-.11l.194-.043a8.742,8.742,0,0,1,1.714-.171v1.581c0,.917.825.943,1.277.533l3.351-2.5a1.031,1.031,0,0,0,.367-.642.975.975,0,0,0-.367-.642L28.959,9.591c-.459-.41-1.278-.386-1.278.534v1.666a10.619,10.619,0,0,0-1.594.136l-.113.017-.165.029A10.691,10.691,0,0,0,17,22.509v.011s0,1.089.983,1.089c.923,0,.959-1.092.959-1.092v-.008a8.75,8.75,0,0,1,.32-2.343l.028.005a8.75,8.75,0,0,1,4.849-5.665Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.367,46.558c-.923,0-.959,1.092-.959,1.092v.011a8.8,8.8,0,0,1-.427,2.709h-.018a8.689,8.689,0,0,1-8.273,6.053h-.02V54.837c0-.917-.794-.943-1.249-.533l-3.337,2.5a1.034,1.034,0,0,0-.358.642.974.974,0,0,0,.374.642l3.317,2.5c.459.409,1.252.385,1.252-.534V58.379A10.8,10.8,0,0,0,50.349,47.661V47.65S50.349,46.558,49.367,46.558Z",
    transform: "translate(-9.988 -25.174)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.7.474H.819L.522-6.4H3ZM.453,2.615a1.072,1.072,0,0,1,.37-.839,1.338,1.338,0,0,1,.922-.328,1.338,1.338,0,0,1,.922.328,1.072,1.072,0,0,1,.37.839,1.072,1.072,0,0,1-.37.839,1.338,1.338,0,0,1-.922.328,1.338,1.338,0,0,1-.922-.328A1.072,1.072,0,0,1,.453,2.615Z",
    transform: "translate(-4709.203 -6734.894)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForceReset);
export default __webpack_public_path__ + "static/media/force-reset.26a926a9.svg";
export { ForwardRef as ReactComponent };